import type { PermissionLevel } from '@atlassian/proforma-common-core/jira-common-models';

export const readOnlyPermissions: PermissionLevel = {
	download: true,
};
export const editPermissions: PermissionLevel = {
	...readOnlyPermissions,
	save: true,
	submit: true,
	reopen: true,
	delete: true,
	toggleAccess: true,
	addForm: true,
};
export const adminPermissions: PermissionLevel = {
	...editPermissions,
	unlock: true,
};

export const FORM_RESTRICTION_URL =
	'https://support.atlassian.com/jira-service-management-cloud/docs/restrict-who-can-view-forms/';
